import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Header from "./components/Header";
import FilterBar from "./components/FilterBar";
import ReplaceModeTip from "./components/ReplaceModeTip";
import TourList from "./components/TourList";
import ConfirmModal from "./components/ConfirmModal";

export default function RouteListPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isReplaceMode = (location.state as { replace?: boolean })?.replace === true;

  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingId, setPendingId] = useState<number | null>(null);
  const [pendingName, setPendingName] = useState("");
  const [keyword, setKeyword] = useState("");
  const [activeDuration, setActiveDuration] = useState(0);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const handleSelect = (id: number) => {
    if (isReplaceMode) {
      setPendingId(id);
      setShowConfirm(true);
    } else {
      navigate("/route-detail-product", { state: { routeId: id } });
    }
  };

  // 从列表中找到选中项的名称（由 TourList 内部通过回调传递）
  const handleSelectWithName = (id: number, name?: string) => {
    if (name && isReplaceMode) {
      setPendingName(name);
    }
    handleSelect(id);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    navigate("/ai-plan");
  };

  return (
    <div className="min-h-screen pb-10" style={{ background: "#F8F9FC", fontFamily: "'Inter','SF Pro Text',sans-serif" }}>
      {/* Fixed Header + Filter */}
      <div className="sticky top-0 z-40">
        <Header keyword={keyword} onSearch={setKeyword} />
        <div className="bg-white" style={{ boxShadow: "0 1px 0 #F3F4F6" }}>
          <FilterBar
            activeDuration={activeDuration}
            minPrice={minPrice}
            maxPrice={maxPrice}
            onDurationChange={setActiveDuration}
            onMinPriceChange={setMinPrice}
            onMaxPriceChange={setMaxPrice}
          />
        </div>
      </div>

      <ReplaceModeTip isReplaceMode={isReplaceMode} />

      {/* Tour List with API integration */}
      <TourList
        activeDuration={activeDuration}
        keyword={keyword}
        minPrice={minPrice}
        maxPrice={maxPrice}
        isReplaceMode={isReplaceMode}
        onSelect={handleSelect}
      />

      {/* Confirm Modal */}
      <ConfirmModal
        show={showConfirm}
        selectedName={pendingName}
        onCancel={() => setShowConfirm(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
}
